import script from "./room_impl.vue?vue&type=script&lang=js"
export * from "./room_impl.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__